import React from "react"

export const languages = {
  french: "fr",
  english: "en"
};

const LanguageContext = React.createContext(languages.french);

export default LanguageContext;